import React, { useEffect,useState,useRef } from 'react'
import Header from './Header'
import Footer from './Footer'
import { messageDisplay } from '../Auth/Util';
import { capFirst, sendCordinates } from '../Logic/index01';
import { useParams } from 'react-router-dom';

const Me = () => {

  const [permission, setPermission] = useState(false);
  const [recording, setRecording] = useState(false);
  const [audioUrl, setAudioUrl] = useState(null);
  const [requestLocation, setrequestLocation] = useState("Send Alert");
  const [countdown, setCountdown] = useState(12);
  const [number, setNumber] = useState("");
  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [msg, setMsg] = useState("");
  const [lats, setlats] = useState([]);
  const [battery, setBattery] = useState({ level: 0});


 
  const {e} = useParams();
  const mediaRecorderRef = useRef(null);
  const streamRef = useRef(null);
  const audioChunksRef = useRef([]);
  const isRecordingRef = useRef(false); 
  const uploadUrlref = useRef(null); 
  const mediaStreamRef = useRef(null);




async function requestUserPermission(){
    try {
     const userLocation  = await getMicrophonePermission()
      if(userLocation != null){
        console.log(`MES ${uploadUrlref.current}`);
        requestUserMedia();
      }
    } catch (err) {
      alert("Permission denied or microphone error: " + err.message);
    }
}






  const sendLocation2min = async () => {
     setInterval(() => {
        setrequestLocation("📍..")
          if(navigator.geolocation)
               navigator.geolocation.getCurrentPosition(async (position) => {
                 setrequestLocation("Send Alert")
                    if(position != null){
                      if(countdown == 12){
                        console.log(position.coords);
                        setlats([position.coords.latitude,position.coords.longitude]);
                        await sendCordinates([position.coords.latitude,position.coords.longitude],e,0,msg,battery.level);
                          
                       
             }}},(error) => {
               messageDisplay(error.message,1)          
       });
       
    },200000);


};






const getMicrophonePermission = async () => {
     setrequestLocation("📍..")
          if(navigator.geolocation){
              const position = await new Promise((resolve, reject) => {
                  navigator.geolocation.getCurrentPosition(resolve, reject);
                });
               try {
                 if(position){
                    setrequestLocation("Send Alert")
                     if(position != null){
                       if(countdown == 12){
                          setlats([position.coords.latitude,position.coords.longitude]);
                          let res = await sendCordinates([position.coords.latitude,position.coords.longitude],e,1,msg,battery.level);
                            if(res?.data != null){
                              if(typeof res.data == "string"){
                                  messageDisplay(`Failed: ${res.data}`,1);
                              }else{ 
                                  console.log(res.data);
                                  sendLocation2min();
                                  uploadUrlref.current = res.data[0];
                                  setName(res.data[1]);
                                  setNumber(res.data[2]);
                                  setAddress(res.data[3])

                                  if (!("MediaRecorder" in window)) {
                                    messageDisplay("The MediaRecorder API is not supported in your browser.",1);
                                    return;
                                  }
                                  }
                                }
                             }
                          }  
                        return position;  
                     }
                  }catch(e){             
                     messageDisplay("The MediaRecorder API is not supported in your browser: "+e,1);
                    return null;
              }
        }
    };





  async function requestUserMedia(){
    try {
          let streamData = streamRef.current;
          
          if (!streamData || !streamData.active) {
            streamData = await navigator.mediaDevices.getUserMedia({ audio: true });
            streamRef.current = streamData; // Keep reference uniform
          }

          setPermission(true);
          isRecordingRef.current = true; // Mark as recording active
          setRecording(true);

          // 2. Hand off control to the start recording engine
        startRecording(streamData);
      

    } catch (err) {
      alert("Permission denied or microphone error: " + err.message);
    }
}




  const startRecording = (stream) => {
    setCountdown(12);
    audioChunksRef.current = []; 
    let selectedMimeType = "";
    // 1. Detect the best supported container format at startup/recording time
    if (MediaRecorder.isTypeSupported("audio/ogg; codecs=opus")) {
      selectedMimeType = "audio/ogg; codecs=opus";
    } else if (MediaRecorder.isTypeSupported("audio/webm; codecs=opus")) {
      selectedMimeType = "audio/webm; codecs=opus"; //Chrome / Edge / Firefox fallback
    } else if (MediaRecorder.isTypeSupported("audio/webm")) {
      selectedMimeType = "audio/webm";
    } else if (MediaRecorder.isTypeSupported("audio/mp4")) {
      selectedMimeType = "audio/mp4"; //Legacy Safari/iOS fallback
    }
    const media = new MediaRecorder(stream, { mimeType: selectedMimeType });
    mediaRecorderRef.current = media;
    // Collect data
    media.ondataavailable = (event) => {
      if (event.data && event.data.size > 0) {
        audioChunksRef.current.push(event.data);
      }
    };

  // IMPORTANT: What happens when the timer triggers media.stop()
  media.onstop = () => {
    const audioBlob = new Blob(audioChunksRef.current, { type: selectedMimeType });
    const audioUrl = URL.createObjectURL(audioBlob);
    console.log("Recording finished! Audio URL:", audioUrl);
    
    // Save your audio URL to state here if needed (e.g., setAudioUrl(audioUrl))
    
    // Reset flags cleanly so the next click can start fresh
    isRecordingRef.current = false;
    setRecording(false);
  };

  // Start the hardware recording
  media.start();

  let timeLeft = 12; 
  const defaultinterval = setInterval(() => {
    timeLeft -= 1;  
    setCountdown(timeLeft);
    console.log(`Ticks left: ${timeLeft}`);

    if (timeLeft <= 0) {
      clearInterval(defaultinterval);
      
      // Safety check: ensure media recorder is active before stopping
      if (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive") {
        mediaRecorderRef.current.stop(); 
        stopRecording();
        
      }
    }
  }, 1000);
};




  
 
  // 3. Stop Recording
  const stopRecording = () => {
    if(isRecordingRef.current){        
        mediaRecorderRef.current.onstop = () => {
                const audioBlob = new Blob(audioChunksRef.current, { type:  "audio/ogg" });
                const audioUrl = URL.createObjectURL(audioBlob);
                setAudioUrl(audioUrl);
                mediaRecorderRef.current.blobData = audioBlob;
               if(audioUrl != null && uploadUrlref.current.length > 0){
                    uploadAudio();
                }else{
                  messageDisplay("Voice note failed to capture properly, but your locaion has been sent out!",1);
                  closeUp();
              }
          };
    }
  };





  




  const uploadAudio = async () => {
      const blob = mediaRecorderRef.current?.blobData;
      if (!blob) {
        alert("No voice note recorded to upload.");
        return;
      }
      try {
        const serverResponse = await fetch(uploadUrlref.current, {
          method: "PUT",
          headers: {
            "Content-Type": "audio/ogg", 
          },
          body: blob,
        });

        if (serverResponse.ok) {
          messageDisplay("Voice note & cordinates has been sent out.",0);
          closeUp();
        } else {
          //console.log(serverResponse.status);
          //console.log(serverResponse.statusText);
          alert("Upload failed.");
        }
      } catch (error) {
        console.error("Error uploading to:", error);
        alert("An error occurred during upload.");
      } 
};







  function closeUp(){
    try {
    if (mediaRecorderRef.current && mediaRecorderRef.current.state !== "inactive") {
      mediaRecorderRef.current.stop();
    }
  } catch (err) {
    console.error("Error stopping MediaRecorder:", err);
  } 

  const activeStream = mediaStreamRef.current || streamRef.current;
  
  if (activeStream) {
    activeStream.getTracks().forEach((track) => {
      track.stop(); // This turns off the recording.
    });
    
    mediaStreamRef.current = null;
    if (streamRef) streamRef.current = null;
  }

  setCountdown(12);
  isRecordingRef.current = false;
  setRecording(false);
  }





   
useEffect(() => {
  if (!('getBattery' in navigator)) {
      return;
    }
    navigator.getBattery().then((bat) => {   
      setBattery({level:Math.round(bat.level * 100)});
    });
    
  return () => {
    if (mediaStreamRef.current) {
      mediaStreamRef.current.getTracks().forEach((track) => track.stop());
    }
  };
}, []);


 
    
  return (
    <>
      <Header/>            
           <div class="bg-neutral-200 min-h-screen flex items-center justify-center  lg:hidden">
            <main class="relative mt-20 w-full max-w-[400px] h-[852px] max-h-[85vh] bg-[#f1f5f9] rounded-[40px] border border-neutral-300 overflow-hidden flex flex-col">
                <header class="flex items-center justify-between px-6 mt-6">
                <div class="flex items-center gap-4">
                    <h1 class="text-2xl font-semibold text-neutral-900">Share my panic alert</h1>
                </div>
                </header>
        
                
                <section class="mt-10 flex flex-col items-center text-center px-6">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" class="text-neutral-900"><circle cx="12" cy="12" r="8"/><circle cx="12" cy="12" r="3.5"/><path d="M12 1v4M12 19v4M1 12h4M19 12h4" stroke-linecap="round"/></svg>
                <p class="mt-3 text-[13px] leading-[1.2] text-neutral-900 font-medium">
                   {capFirst(address)}
                </p>
                {lats.length > 0 ? <p class="mt-3 text-[13px] font-bold text-neutral-900">Lat: {lats[0].toString().length > 6 ? lats[0].toString().substring(0,6) : lats[0]}, &nbsp; Lng: {lats[1].toString().length > 6 ? lats[1].toString().substring(0,6) : lats[1]}</p> : "..."}
                </section>
            
            
                <section class="mt-8 flex justify-center">
                <button onClick={requestUserPermission} class="w-[234px] h-[234px] rounded-full bg-neutral-300/80 flex items-center justify-center active:scale-95 transition-transform focus:outline-none focus-visible:ring-4 focus-visible:ring-red-400">
                    <span class="w-[188px] h-[188px] rounded-full bg-neutral-400/90 flex items-center justify-center">
                    <span  style={isRecordingRef.current ? {backgroundColor:"#1cde12"} : {backgroundColor:"#737373"}} class="w-[160px] h-[160px] rounded-full  from-neutral-300 via-neutral-500 flex items-center justify-center shadow-inner">
                        <span class="text-white text-[40px] font-semibold leading-[1.05] text-center">{requestLocation}</span>
                    </span>
                    </span>
                </button>
                </section>
            
                {name.length > 0 ?
                <section class="mt-10 flex items-center gap-3 justify-center"> {/*pl-12*/}
                {/* <img src="https://i.pravatar.cc/100?img=12" alt="Father" class="w-12 h-12 rounded-full object-cover bg-amber-200 shrink-0" /> */}
                <a href={`tel:${number}`} class="shrink-0 flex items-center w-[220px] h-[50px] px-4 rounded-xl bg-[#e69aa0] border border-[#d9808a] text-white self-center">
                    <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M5 4h4l2 5-2.5 1.5a11 11 0 0 0 5 5L15 13l5 2v4a2 2 0 0 1-2 2A16 16 0 0 1 3 6a2 2 0 0 1 2-2z"/><path d="M15 3a6 6 0 0 1 6 6M15 6a3 3 0 0 1 3 3"/></svg>
                    <span class="leading-tight">
                    <span class="block text-[15px] font-semibold">&nbsp; {capFirst(name)}</span>
                    <span class="block text-xs opacity-90">&nbsp; {number}</span>
                    </span>
                </a>
                </section>
                : <br/>}
            
                <br/>
                <section class="mt-auto mx-4 mb-1 h-[120px] bg-white rounded-lg border border-neutral-200 flex flex-col">
                   <textarea value={msg}   onChange={(e) => setMsg(e.target.value)}  aria-label="Message" class="flex-1 resize-none bg-transparent p-3 text-sm outline-none rounded-2xl" placeholder='Write short message'></textarea> 
                </section>
            
            </main>
            </div>

      <Footer/>
    </>
  )
}

export default Me
